import CollectionComposer from "./collection-composer";
import Pagination from "components/common/Pagination";
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';
import React from "react";

const DisplayComposer = ({
    isMenuActive,
    isClickedBtn,
    handleShowComposer,
    composers,
    setComposers,
    isLoadingComposer,
    links,
    searchString,
    payload,
}) => {
    return (
      <>
        {
          isMenuActive === 2 && isClickedBtn === 2 &&
          <div className="w-full">
            {!isLoadingComposer ?
              <>
                <CollectionComposer
                  data={composers}
                  handleShowComposer={handleShowComposer}
                />
              </>
              :
              <Skeleton containerClassName="w-full" height={300} count={15} />
            }
            {/* {(searchString && links) || (!searchString && links) && */}
              <Pagination 
                links={links} 
                setData={setComposers} 
                payload={payload} 
              />
            {/* } */}
          </div>
        }
      </>
    )
  }
export default DisplayComposer;
